module.exports = __webpack_public_path__ + "img/joco-works-logo.7d2b3016.jpg";